import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["userId", "limit", "offset", "weekCommencingDate", "skillId"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery, useQueryClient } from '@tanstack/react-query';
import api from 'utils/api';
import { DEFAULT_ITEMS_PER_PAGE } from 'utils/pagination';
import usersKeys from './queryKeys';
export function fetchUserAnalysisSkills(_x) {
  return _fetchUserAnalysisSkills.apply(this, arguments);
}
function _fetchUserAnalysisSkills() {
  _fetchUserAnalysisSkills = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _ref$limit, limit, skillId, userId, _ref$offset, offset, weekCommencingDate;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? DEFAULT_ITEMS_PER_PAGE : _ref$limit, skillId = _ref.skillId, userId = _ref.userId, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? 0 : _ref$offset, weekCommencingDate = _ref.weekCommencingDate;
          return _context.abrupt("return", api('get', '/api/userAnalysis/skills', {
            limit: limit,
            offset: offset,
            userId: userId,
            weekCommencingDate: weekCommencingDate,
            skillId: skillId
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchUserAnalysisSkills.apply(this, arguments);
}
function useFetchUserAnalysisSkills(_ref2) {
  var userId = _ref2.userId,
    limit = _ref2.limit,
    offset = _ref2.offset,
    weekCommencingDate = _ref2.weekCommencingDate,
    skillId = _ref2.skillId,
    queryOptions = _objectWithoutProperties(_ref2, _excluded);
  var queryClient = useQueryClient();
  var currentKey = usersKeys.singleUserAnalysisSkills({
    skillId: skillId,
    userId: userId,
    weekCommencingDate: weekCommencingDate,
    limit: limit,
    offset: offset
  });
  var _useQuery = useQuery(_objectSpread(_objectSpread({}, queryOptions), {}, {
      queryFn: function queryFn() {
        return fetchUserAnalysisSkills({
          limit: limit,
          skillId: skillId,
          userId: userId,
          offset: offset,
          weekCommencingDate: weekCommencingDate
        });
      },
      initialData: function initialData() {
        // Try to pull from cache for instant render
        var cached = queryClient.getQueryData(currentKey);
        return cached;
      },
      queryKey: currentKey,
      staleTime: 5 * 60 * 1000
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data || {}
  }, result);
}
export default useFetchUserAnalysisSkills;